import { Subject } from "rxjs";
import { CerLink } from "./cer-link";
import { CerUserThemeHelper } from "src/cer-app/cer-app-theme/cer-app-theme.service";
import { CerFormZoom } from "@cer/cer-form/cer-form-zoom/cer-form-zoom";

declare global {
    interface WindowEventMap {
        'cer-mermaid-click-event': CustomEvent;
    }
}

export const CerMermaidClickEvent = 'cer-mermaid-click-event';

(window as any).nodeClick = function (...params: any[]) {
    const p: string[] = params.map(pAny => <string>pAny);
    const event = new CustomEvent(CerMermaidClickEvent, {
        bubbles: true,
        detail: p
    });
    window.dispatchEvent(event);
};

export class CerMermaid {
    public linksClicked: Subject<CerLink[]> = new Subject<CerLink[]>();
    private onLinkClickHandler = this.onLinkClick.bind(this);
    private formZoom: CerFormZoom = new CerFormZoom();
    
    constructor(private mermaid: any, private id: string) {
        mermaid.setClickEvent = this.onLinkClick.bind(mermaid);
        const theme = CerUserThemeHelper.activeTheme() == 'dark' ? 'dark' : 'redux'/*'default'*/;
        mermaid.initialize({ /*logLevel: 3,*/ htmlLabels: true,startOnLoad: false, securityLevel: 'loose', theme: theme });
        window.addEventListener(CerMermaidClickEvent, this.onLinkClickHandler, false);
    }

    public dispose() {
        window.removeEventListener(CerMermaidClickEvent, this.onLinkClickHandler, false);
        this.formZoom.destroy();
    }

    public static canRefresh(div: HTMLDivElement) {
        if (div == null) {
            return false;
        }
        if (div.querySelectorAll('pre.mermaid').length == 0) {
            return false; // No mermaids
        }
        if (div.querySelectorAll('svg').length > 0) {
            return false; // Mermaids is rendered
        }
        return true;
    }

    public static async createAndRun(id: string) : Promise<CerMermaid> {
        const mermaidType = await import("mermaid");
        const cerMermaid = new CerMermaid(mermaidType.default, id);
        cerMermaid.run();
        return cerMermaid;
    }

    private static nodeIdPrefix = "Node_";
    public static linkRefine(markdown: string, id: string): string {
        const callClick = "call nodeClick(";
        markdown = markdown.replaceAll(callClick, callClick + id + ","); // add service id to links to ensure only this service trigger links
        const exp = "(click (.*) call nodeClick[(])(.*)([)] \")(.*)(\")";
        const subst = '$1Node_$2,$5,$3$4$5';
        const regex = new RegExp(exp, 'g');
        markdown = markdown.replaceAll(regex,
            function (total, pre, id, links, sep, title, post): string {
                return pre + CerMermaid.nodeIdPrefix + id + "," + title.replaceAll(" ", "_") + "," + links + sep + title + post;
            });
        return markdown;
    }

    public onLinkClick(e: CustomEvent) {
        var urls: string[] = e.detail as string[];
        var id = '';
        var title = 'Link';
        if (urls.length > 2 && urls[0].startsWith(CerMermaid.nodeIdPrefix)) {
            id = urls[0].replace(CerMermaid.nodeIdPrefix, '');
            title = urls[1].replaceAll("_", " ");
            urls = urls.slice(2);
        }
        if (urls?.length <= 1) {
            // No links
            return;
        }
        if (urls[0] != this.id) {
            // Other mermaid instance
            return;
        }
        const  hrefs = urls.slice(1);

        const links: CerLink[] = [];
        for (const href of hrefs) {
            const link = new CerLink();
            link.title = title;
            link.url = href;
            link.id = id;
            links.push(link);
        }
        this.linksClicked.next(links); // calls CerLink.init()
    }

    public run() {
        const _this = this;
        const onPostRender = this.onMermaidPostRender.bind(this);
        this.mermaid.run({
            querySelector: '.mermaid',
            postRenderCallback: (id: string) => {
                _this.mermaidId = id;
                onPostRender();
            }
        });
    }

    public mermaidId: string = null;
    public onMermaidPostRender() {
        const svgElement = document.getElementById(this.mermaidId);
        if (svgElement && svgElement instanceof SVGSVGElement && svgElement.parentElement) {
            this.addZoom(svgElement.parentElement);
            //this.linkIdSvg(svgElement,this.mermaidId);
        }
    }

    /*private linkIdSvg(svgElement: HTMLElement & SVGSVGElement, id: string) {
        svgElement.querySelectorAll('.clickable').forEach(a => {
            console.log(a);
        })
    }*/

    public addZoom(container: HTMLElement): void {
        this.formZoom.add(container);
    }

    /*private mermaidSetClickEvent(ids: string, functionName: string, functionArgs: any) {
        const thisAny: any = this; // is mermaid obj
        ids.split(",").forEach((id) => {
            thisAny.setClickFun(id, functionName, functionArgs);
        });
        thisAny.setClass(ids, 'clickable');
    }*/
}

